import React from "react";

// import pages
import FooterB from "./layout/FooterB";

// import style
import "../style/pages/notfound.scss";

const NotFound = () => {
  return (
    <div className="notfound-section">
      <div className="container main-section">
        <h1 className="error-404">404</h1>
        <h1 className="title">Page Not Found</h1>
        <p className="text">Sorry, this page does not exist!</p>
        <a className="link" href="/">
          Go Back To First Page
        </a>
      </div>
      <FooterB />
    </div>
  );
};

export default NotFound;
